"use client";

import React, { useEffect, useState } from "react";
import AccordionPanel from "./AccordionPanel";
import {
  ClassResponse,
  ContentResponse,
} from "../../services/api.response.service";
import { useSelector } from "react-redux";
import { IRootState } from "../../redux/states";
import { getLanguageByDefault } from "../../services/app.service";
import { Mixpanel } from "../../services/mixpanel";
import Api from "../../services/api.service";
import { toInteger } from "lodash";
import {
  ContentMediaBadges,
  contentHasMediaBadges,
} from "./ContentMediaBadges";

export default function CoursesSection({
  classDetails,
  contentId,
  isShortForm = false,
  handleSetCourse,
}: {
  classDetails: ClassResponse;
  contentId?: number;
  isShortForm?: boolean | false;
  handleSetCourse: (id: string, title: string) => void;
}) {
  const getLanguage = getLanguageByDefault();
  const [activeSector, setActiveSector] = React.useState<number>(-1);

  const stateAll = useSelector((state: IRootState) => state);
  const currentUser = stateAll.setting.user!;

  const [contents, setContents] = useState<ContentResponse[] | []>([]);
  const [currentTopicId, setCurrentTopicId] = useState<number | null>(
    contentId ?? null,
  );

  function hasTopics(content: ContentResponse) {
    return content.total_topics > 0;
  }

  function setTheCourse(id: string, title: string) {
    const input = document.getElementById(
      `topic-check-${id}`,
    ) as HTMLInputElement;
    if (input) {
      input.checked = true;
    }

    Mixpanel.track("Tap Course Outline item", {
      with: currentUser?.id ? "Auth" : "Guest",
      user_id: currentUser?.id,
      course_id: id,
      course_name: title,
      ...(classDetails?.content_provider_id
        ? { content_provider_id: classDetails?.content_provider_id }
        : {}),
    });
    handleSetCourse && handleSetCourse(id, title);
  }

  const getContents = async (classId: string | number) => {
    // const contentsObj = await Api.getClassCourseStructure((toInteger(classId)));
    const contentsObj = await Api.getClassCourses(toInteger(classId));
    if (contentsObj) {
      // console.log("contents",contentsObj.data.data);
      let theCourses = contentsObj.data.data as ContentResponse[] | [];

      theCourses?.map(async (course, index) => {
        // console.log("course", course.id,course.total_topics);
        if (hasTopics(course)) {
          let topics = await getTopics(course.id);
          if (topics) {
            course.topics = topics;
          }
        }
      });
      // console.log("theCourses", theCourses);
      if (theCourses) {
        setContents(theCourses);
      }
      // setContents(theCourses);
      return theCourses;
    }
    return null;
  };
  const getTopics = async (contentId: string | number) => {
    // const contentsObj = await Api.getClassCourseStructure((toInteger(classId)));
    const contentsObj = await Api.getCourseTopics(toInteger(contentId));
    if (contentsObj) {
      let theTopics = contentsObj.data.data as ContentResponse[];

      theTopics.map(async (course, index) => {
        // console.log("topic", course.id,course.total_topics);
        if (hasTopics(course)) {
          if (hasTopics(course)) {
            let topics = await getTopics(course.id);
            if (topics) {
              course.topics = topics;
            }
          }
        }
      });
      // console.log("theTopics",theTopics);
      return theTopics;
    }
    return null;
  };

  function getTopicView(topic: ContentResponse, index: number) {
    const isCurrent = topic.id === currentTopicId;
    const isCompleted = (topic.user_points?.length ?? 0) > 0;
    const rowClass = [
      "topic-row",
      "row",
      "col-12",
      "mt-1",
      isCurrent && "topic-row--current",
      isCompleted && !isCurrent && "topic-row--completed",
    ]
      .filter(Boolean)
      .join(" ");

    return (
      <div key={topic.id} className={rowClass}>
        <div className={"hover-underline row col-12 "}>
          <div className={`${isShortForm ? "col-sm-12" : "col-sm-8"}`}>
            {isShortForm && (
              <input
                id={`topic-check-${topic.id}`}
                type={"checkbox"}
                className="topic-row__checkbox"
                checked={isCompleted}
                style={{
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onChange={() => {}}
              />
            )}

            <span
              className="topic-fw text-black justify-content-start"
              style={{
                cursor: "pointer",
                fontWeight: isCurrent ? "600" : "400",
              }}
              onClick={() => {
                setTheCourse(String(topic?.id), topic.title);
                setCurrentTopicId(topic?.id);
              }}
            >
              {index + 1}. {topic.title}
            </span>
          </div>

          <div className={`${isShortForm ? "col-sm-12" : "col-sm-4"}`}>
            <ContentMediaBadges
              content={topic}
              isShortForm={isShortForm}
              lang={{
                watch: getLanguage.watch,
                listen: getLanguage.listen,
                read: getLanguage.read,
              }}
            />
          </div>
        </div>
        {hasTopics(topic) && (
          <div className="m-1 mx-3">
            {topic.topics?.map((subTopic, subIndex) =>
              getTopicView(subTopic, subIndex),
            )}
          </div>
        )}
      </div>
    );
  }

  useEffect(() => {
    if (classDetails?.id) {
      getContents(classDetails.id)
        .then((res) => {
          // console.log("contents",res);
        })
        .catch((err) => {
          console.error("Error fetching contents", err);
        });
    }
  }, [classDetails]);

  return (
    <div className="col-12">
      {contents &&
        contents.length > 0 &&
        contents.map((course, i) => (
          <AccordionPanel
            key={course.id}
            content={course}
            title={course.title}
            headerBadges={
              contentHasMediaBadges(course) ? (
                <ContentMediaBadges
                  content={course}
                  isShortForm={isShortForm}
                  justifyMain="start"
                  lang={{
                    watch: getLanguage.watch,
                    listen: getLanguage.listen,
                    read: getLanguage.read,
                  }}
                />
              ) : undefined
            }
            subTitle={
              hasTopics(course)
                ? `${course.total_topics || course.topics?.length} ${getLanguage.topics} `
                : isShortForm
                  ? ""
                  : course.description
            }
            showItems={hasTopics(course)}
            setIsOpen={() =>
              setActiveSector((previous) => (previous == i ? -1 : i))
            }
            isOpen={activeSector == i}
            handleHeadClick={() => {
              handleSetCourse &&
                handleSetCourse(String(course?.id), course.title);
            }}
          >
            <div>
              <div className="m-4">
                {hasTopics(course) &&
                  course.topics &&
                  course.topics.length > 0 &&
                  course.topics.map((topic, index) =>
                    getTopicView(topic, index),
                  )}
              </div>
            </div>
          </AccordionPanel>
        ))}
    </div>
  );
}
